import compact from 'lodash/compact'
import keyBy from 'lodash/keyBy'

// `loadPickList()` expects products in the master-data shape:
// { byId: { [productId]: productDoc }, allIds: [productId] }.
export const buildProductsForPickList = (products, shipmentProductIds) => {
  const productsById = keyBy(products, '_id')
  // `pick-list-reducer` looks up `action.products.byId[productId]`, where `productId` comes
  // directly from `shipment.counts`.
  //
  // Some EPN shipments keep those ids in their original casing, while `product.getByIds()`
  // returns docs under the canonical lowercase `_id`. Add both keys to the same product doc
  // so the reducer can resolve the shipment counts correctly.
  //
  // This is only bridging shipment ids to canonical product docs. It is not generic-product
  // expansion and it is intentionally much narrower than loading all shipment master data.
  const shipmentProductAliases = Object.fromEntries(
    compact(
      shipmentProductIds.map(productId => {
        const matchedProduct = productsById[productId] || productsById[productId.toLowerCase()]
        return matchedProduct ? [productId, matchedProduct] : null
      })
    )
  )

  return {
    byId: {
      ...productsById,
      ...shipmentProductAliases
    },
    allIds: products.map(product => product._id)
  }
}
